import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

import { Card } from './internal/components/Card';
import { MainCard } from './internal/components/MainCard';

import styles from './PikInNumbersV2.css';

type TPikInNumbersV2Props = {
  id: string;
  onView: () => void;
};

export const PikInNumbersV2: FC<TPikInNumbersV2Props> = ({ id, onView }) => {
  return (
    <LayoutBlock id="pik-in-numbers-v2" title="ПИК в цифрах" onView={onView}>
      <div className={styles['container']} data-testid={`${id}-cards`}>
        <MainCard description="в 14 регионах РФ сейчас в реализации ПИК" title=">150 жилых кварталов" />
        <Card
          imageAlt="Женщина отдыхает на крыше жилого дома ПИК с книгой, рядом идёт кот"
          description="жилья введено за всю историю компании 30+ лет"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-square-meters.webp"
          title="37 млн м²"
        />
        <Card
          imageAlt="Пара с котом переезжает в новую квартиру ПИК с коробками"
          description="семей проживает в кварталах ПИК"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-families.webp"
          title=">650 тыс. семей"
        />
        <Card
          imageAlt="Дети играют на детской площадке у жилого комплекса"
          description="поликлиник — 26, школ — 57, детсадов — 142"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-objects.webp"
          title=">225 объектов"
        />
        <Card
          imageAlt="Сотрудник ПИК с планировкой квартиры на мольберте и планшетом"
          description="человек работает над проектами ПИК"
          imageSrc="https://static.cdn-cian.ru/frontend/newbuilding-b2b-assets/images/pik/pik-in-numbers/card-persons-qty.webp"
          title=">30 тысяч"
        />
      </div>
    </LayoutBlock>
  );
};
